import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const HeartFillIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 15 14"
    >
      <path
        d="M7.21243 12.4951L1.59643 6.87113C0.896005 6.17295 0.501605 5.22511 0.500005 4.23614C0.498415 3.24717 0.889755 2.29807 1.58793 1.59763C2.28611 0.897192 3.23395 0.502802 4.22292 0.501202C5.2119 0.499612 6.16101 0.890952 6.86143 1.58913V1.59413L7.20743 1.94113L7.55343 1.59413C7.89861 1.24775 8.3087 0.972822 8.7602 0.785082C9.2118 0.597342 9.6959 0.500472 10.1849 0.500002C10.6739 0.499542 11.1582 0.595492 11.6101 0.782382C12.062 0.969262 12.4726 1.24341 12.8184 1.58913L12.8234 1.59413C13.5217 2.29493 13.9137 3.24387 13.9137 4.23313C13.9137 5.22239 13.5217 6.17133 12.8234 6.87213L7.21243 12.4951Z"
        fill="#CC4039"
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth={strokeWidth || 1.5}
      />
    </BaseIcon>
  ),
);

HeartFillIcon.displayName = 'HeartFillIcon';
